export default __webpack_public_path__ + "static/toolsImage3-8762d75d256150bb0301c1369c22a0cd.webp";